import { useIntl } from '@capsicum/common';
import { WCPledgeStatus } from '@capsicum/features/world-championship-pledge/shared';

export const useWCPledgeButtonProperties = (status: WCPledgeStatus) => {
	const { $t } = useIntl();

	return {
		// TODO: Add the proper texts and redirection according to the status when we have all the cases defined
		WCPledgeCardButtonText:
			status === WCPledgeStatus.OPENED
				? $t('worldChampionshipPledge.entryPoint.cardEnterButtonTitle')
				: $t('worldChampionshipPledge.entryPoint.cardEnterButtonTitle')
	};
};
